import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const MachineLinkName = styled.span`
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  color: ${tokens.accent.onDark};
  cursor: pointer;
  transition: color ${tokens.motion.duration} ${tokens.motion.ease};

  &:hover {
    color: ${tokens.accent.base};
    text-decoration: underline;
  }
`
